// src/components/Report/reportStyles.ts
import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  // COVER PAGE
  coverPage: {
    fontFamily: 'Roboto',
    position: 'relative',
  },
  coverContent: {
    paddingTop: 60,
    paddingBottom: 60,
    paddingHorizontal: 50,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  // CONTENT PAGES: constants
  page: {
    backgroundColor: '#d8d8d8',
    fontFamily: 'Roboto',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    // IMPORTANT: Reserve space for header/footer to avoid overlap on automatic page breaks
    // contentPaddingYTop = 20, headerHeight = 60, headerGap = 10
    // contentPaddingYBottom = 20, footerHeight = 40, footerGap = 10
    paddingTop: 20 + 60 + 10,
    paddingBottom: 20 + 40 + 10,
    // content horizontal padding
    paddingHorizontal: 50,
  },
  // This container is the flowing content area (respects page padding above)
  contentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  // Fixed header aligned to the same horizontal padding as content
  headerBar: {
    position: 'absolute',
    top: 20, // content vertical padding at top
    left: 50,
    right: 50,
    height: 60,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    // Divider removed per requirement
  },
  logoIso: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #E2E8F0',
    paddingBottom: 15,
  },
  date: {
    fontSize: 12,
    color: 'white',
    textAlign: 'center',
    marginBottom: 10,
    marginTop: 20,
    fontWeight: '500',
    letterSpacing: 0.5,
  },
  pinName: {
    fontSize: 20, 
    fontWeight: 'bold',
    textAlign: 'center',
    color: 'white',
    marginBottom: 15,
    letterSpacing: 0.8,
  },
  backgroundImage: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    opacity: 0.85,
    zIndex: -1,
    objectFit: 'cover',
  },
  reportTitle: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: 36, 
    fontWeight: 'bold',
    alignItems: 'flex-end',
    color: 'white', 
    marginBottom: 5,
    letterSpacing: 2, 
    textTransform: 'uppercase', 
  },
  coverPhotoContainer: { // cover foto nedir sorulacak.
    marginTop: 30,
    marginBottom: 16,
    width: '100%',
    height: 280, 
    borderRadius: 8, 
    overflow: 'hidden',
    border: '1px solid #E2E8F0',
  },
  coverPhoto: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  footer: {
    position: 'absolute',
    bottom: 20, // content vertical padding at bottom
    left: 50,
    right: 50,
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 10,
    color: '#64748B',
    borderTop: '1px solid #E2E8F0',
    paddingTop: 8,
  },
  footerTextLeft: {
    fontSize: 10,
    color: '#64748B',
  },
  footerTextRight: {
    fontSize: 10,
    color: '#64748B',
  },
// New styles for content page
  section: {
    marginTop: 10,
    marginBottom: 10,
    padding: 8,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#003087', // TAV navy blue
    marginBottom: 12,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    borderBottom: '1px solid #E2E8F0',
    paddingBottom: 5,
  },
  sectionTitleNoBorder: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#003087', // TAV navy blue
    marginBottom: 12,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    paddingBottom: 5,
  },
  subheading: {
    fontSize: 14,
    fontWeight: 'medium',
    color: '#003087', // TAV navy blue - same as sectionTitle
  },
  paragraph: {
    fontSize: 12,
    color: '#1F2937',
    lineHeight: 1.6,
    textAlign: 'justify',
  },
  bulletText: {
    fontSize: 12,
    color: '#1F2937',
    marginLeft: 20,
    lineHeight: 1.6,
  },
  boldText: {
    fontWeight: 'bold',
    color: '#003087', // TAV blue for emphasis
  },
  //3. sayfa
  table: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: 6,
    breakInside: 'avoid',
  },
  // Küçük tablo stilleri - tek sayfaya sığması için
  smallTable: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 5,
    marginBottom: 5,
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: 4,
    breakInside: 'avoid',
  },
  smallTableHeader: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#E6EFFF',
    paddingVertical: 4,
    paddingHorizontal: 6,
    borderBottom: '1px solid #E2E8F0',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  smallTableHeaderCell: {
    flex: 1,
    fontSize: 11,
    fontWeight: 'bold',
    color: '#003087',
    textAlign: 'left',
    padding: 2,
  },
  smallTableRow: {
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: 4,
    paddingHorizontal: 6,
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E2E8F0',
  },
  smallTableCell: {
    flex: 1,
    fontSize: 11,
    color: '#003087',
    textAlign: 'left',
    padding: 1,
    lineHeight: 1.2,
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#E6EFFF',
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderBottom: '1px solid #E2E8F0',
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  tableHeaderCell: {
    flex: 1,
    fontSize: 11,
    fontWeight: 'bold',
    color: '#003087',
    textAlign: 'left',
    padding: 4,
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    paddingVertical: 8,
    paddingHorizontal: 10,
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E2E8F0',
  },
  tableCell: {
    flex: 1,
    fontSize: 10,
    color: '#003087',
    textAlign: 'left',
    padding: 2,
  },
  // Definition list alignment
  definitionRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 4,
  },
  definitionTerm: {
    width: 70,
    fontSize: 11,
    fontWeight: 'bold',
    color: '#003087',
  },
  definitionColon: {
    width: 5,
    fontSize: 11,
    fontWeight: 'bold',
    color: '#003087',
  },
  definitionDesc: {
    flex: 1,
    fontSize: 11,
    color: '#1F2937',
  },
  riskLevelCell: {
    flex: 1,
    fontSize: 11,
    textAlign: 'left',
    padding: 8,
    fontWeight: 'medium',
  },
  mapImage: {
    width: '100%',
    height: 170, 
    borderRadius: 8,
    border: '1px solid #E2E8F0', 
    objectFit: 'contain', 
  },
  imageGallery: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 10,
    gap: 10,
  },
  galleryImage: {
    width: 150,
    height: 100,
    borderRadius: 4,
    border: '1px solid #E2E8F0',
    objectFit: 'contain',
  },
  questionSpacer: {
    height: 10,
    borderBottom: '1px dashed #E2E8F0',
    marginVertical: 10,
  },
  attachmentContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 15,
    marginBottom: 15,
    gap: 10,
    breakInside: 'avoid',
  },
  attachmentImage: {
    width: 150,
    height: 100,
    borderRadius: 4,
    border: '1px solid #E2E8F0',
    objectFit: 'contain',
  },
  // TOC styles
  tocRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginBottom: 6,
  },
  tocTitle: {
    fontSize: 16,
    color: '#1F2937',
  },
  articleContainer: {
    marginTop: 12,
    display: 'flex',
    flexDirection: 'column',
  },
  articleRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
  },
  articleText: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  articleParagraph: {
    fontSize: 12,
    color: '#1F2937',
    lineHeight: 1.6,
    textAlign: 'justify',
    marginBottom: 6,
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    hyphens: 'auto',
  },
  articleImageLeft: {
    width: 140,
    height: 100,
    borderRadius: 4,
    border: '1px solid #E2E8F0',
    objectFit: 'cover',
    marginRight: 10,
  },
  articleImageCentered: {
    width: 320,
    height: 210,
    borderRadius: 4,
    border: '1px solid #E2E8F0',
    objectFit: 'cover',
    alignSelf: 'center',
    marginTop: 8,
    marginBottom: 8,
  },
});